// extracted by mini-css-extract-plugin
export default {"new-ui-scroll-to-top":"WjShJo","newUiScrollToTop":"WjShJo"};